/**
=========================================================
* Material Dashboard 3 PRO React - v2.4.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2024 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Card from "@mui/material/Card";
import Tooltip from "@mui/material/Tooltip";
import Icon from "@mui/material/Icon";
import Grid from "@mui/material/Grid";

// Material Dashboard 3 PRO React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import MDBadgeDot from "components/MDBadgeDot";
import PieChart from "examples/Charts/PieChart";

// Material Dashboard 3 PRO React contexts
import { useMaterialUIController } from "context";

// Data dummy untuk status proyek
const statusProyekData = {
  labels: ["On Track", "Behind Schedule", "Completed"],
  datasets: {
    label: "Status Proyek",
    backgroundColors: ["success", "warning", "info"],
    data: [15, 7, 2],
  },
};

function StatusProyekChart() {
  const [controller] = useMaterialUIController();
  const { darkMode } = controller;

  return (
    <Card sx={{ height: "100%" }}>
      <MDBox
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        pt={2}
        px={2}
      >
        <MDTypography variant="h6">Status Proyek</MDTypography>
        <Tooltip
          title="Lihat distribusi status proyek"
          placement="bottom"
          arrow
        >
          <MDButton
            variant="outlined"
            color="secondary"
            size="small"
            circular
            iconOnly
          >
            <Icon>priority_high</Icon>
          </MDButton>
        </Tooltip>
      </MDBox>
      <MDBox mt={3}>
        <Grid container alignItems="center">
          <Grid item xs={7}>
            <PieChart chart={statusProyekData} height="12.5rem" />
          </Grid>
          <Grid item xs={5}>
            <MDBox pr={1}>
              <MDBox mb={1}>
                <MDBadgeDot color="success" size="sm" badgeContent="On Track" />
              </MDBox>
              <MDBox mb={1}>
                <MDBadgeDot
                  color="warning"
                  size="sm"
                  badgeContent="Behind Schedule"
                />
              </MDBox>
              <MDBox mb={1}>
                <MDBadgeDot color="info" size="sm" badgeContent="Completed" />
              </MDBox>
            </MDBox>
          </Grid>
        </Grid>
      </MDBox>
      <MDBox
        pt={4}
        pb={2}
        px={2}
        display="flex"
        flexDirection={{ xs: "column", sm: "row" }}
        mt="auto"
      >
        <MDBox width={{ xs: "100%", sm: "60%" }} lineHeight={1}>
          <MDTypography variant="button" color="text" fontWeight="light">
            Sebanyak <strong>15 proyek</strong> berjalan sesuai jadwal,{" "}
            <strong>7 proyek</strong> tertunda, dan <strong>2 proyek</strong>{" "}
            telah selesai.
          </MDTypography>
        </MDBox>
        <MDBox
          width={{ xs: "100%", sm: "40%" }}
          textAlign="right"
          mt={{ xs: 2, sm: "auto" }}
        >
          <MDButton color={darkMode ? "white" : "light"}>selengkapnya</MDButton>
        </MDBox>
      </MDBox>
    </Card>
  );
}

export default StatusProyekChart;
